import { Box, Container, Typography, Card, useTheme } from '@mui/material';
import Page from '../Page';
import ChangePasswordForm from '../authentication/changePassword/ChangePasswordForm';

export default function ChangePassword() {
  const theme = useTheme();
  
  return (
    <Page title="Change Password | ChargeMiles Dashboard">
      <Container maxWidth="md" sx={{ mt: { xs: 8, md: 10 }, mb: 10 }}>
        <Card sx={{ 
          boxShadow: (theme) => `0 0 4px 0 rgba(145,158,171,0.24), 0 24px 48px 0 rgba(145,158,171,0.24)`,
          borderRadius: 3,
          overflow: "hidden" 
        }}>
          {/* Header Gradient */}
          <Box
            sx={{
              background: `linear-gradient(135deg, var(--app-color) 0%, ${theme.palette.primary.dark} 100%)`,
              color: '#fff',
              p: { xs: 3, md: 4 },
            }}
          >
            <Typography variant="h4" fontWeight={600}>
              Security Settings
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.85, mt: 0.5 }}>
              Update your account password securely
            </Typography>
          </Box>

          <Box sx={{ p: { xs: 3, md: 5 } }}>
            <ChangePasswordForm />
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
